import axios from 'axios';

export default function request(config){
  const instance = axios.create({
    baseURL: 'https://marketing.chuanbaoguancha.cn/v1/community',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }
  });

  instance.interceptors.request.use(config=>{
    config.method = config.method || 'GET';

    config.headers['Accept'] = 'application/json';
    config.headers['Content-Type'] = 'application/json';
    if(config.token){
      config.headers['Authorization'] = `Bearer ${config.token}`
    }
    if(config.headers){
      config.headers['Content-Type'] = config.headers['Content-Type'];
    }
    
    return config;
  },err=>err);
  instance.interceptors.response.use(res=>{
    return config.handleData ? config.handleData(res.data) :res;
  }, err=>err);

  return instance(config);
}
